import React, { useRef } from "react";

import ShopLocatorInfo from "./shopLocator/shopLocatorInfo";
import ShopLocatorSwiper from "./shopLocator/shopLocatorSwiper";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";

const GroupLocator = ({ group }) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const locator = { title: "모임 추천", info: "가입하고 싶은 모임에 가입하세요", type: "group" };
  const swiperRef = useRef();

  const clickEvent = (item) => {
    window.open(`https://1472.ai/group/${item.groupNo}`);
  };

  return (
    <div className="inner">
      <ShopLocatorInfo locator={locator} />
      <ShopLocatorSwiper
        data={group}
        type={locator.type}
        swiperRef={swiperRef}
        clickEvent={clickEvent}
      />
    </div>
  );
};

export default GroupLocator;
